<mat-card>
    <kendo-grid
        [data]="query | async"
        [loading]="isLoading"
        [skip]="state.skip"
        [pageSize]="state.take"
        scrollable="virtual"
        [rowHeight]="36"
        [height]="750"
        (pageChange)="pageChange($event)"
        (excelExport)="onExcelExport($event)"
    >

        <ng-template kendoGridToolbarTemplate>
            <button class="export-to-excel-button" kendoGridExcelCommand>
                <img
                    class="ms-icon"
                    src="assets/icons/excel-icon.svg"
                    style="width: 35px;
                            height: 35px;
                            vertical-align: middle;">
                {{ 'ExportToExcel' | translate: {Default: "Export to Excel"} }}
            </button>

            <div class="k-mb-2">
                <mat-slide-toggle setColor="primaryColour" [checked]="filterInactive" disabled="false"
                                  (change)="toggleFilterInactive($event)">{{ 'ActiveOnly' | translate: {Default: "Active Only"} }}</mat-slide-toggle>
            </div>

            <mat-form-field appearance="outline">
                <mat-label>
                    {{ 'StartDate' | translate: {Default: "Start Date"} }}
                </mat-label>
                <input matInput [matDatepicker]="startDatepicker" [(ngModel)]="filterFrom" (dateChange)="changeFromDate($event)">
                <span fxLayout="row" matSuffix>
                    <mat-datepicker-toggle [for]="startDatepicker"></mat-datepicker-toggle>
                </span>
                <mat-datepicker #startDatepicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>
                    {{ 'EndDate' | translate: {Default: "End Date"} }}
                </mat-label>
                <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="filterTo" (dateChange)="changeToDate($event)">
                <span fxLayout="row" matSuffix>
                    <mat-datepicker-toggle [for]="endDatePicker"></mat-datepicker-toggle>
                </span>
                <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>
                    {{ 'CreatedOnFrom' | translate: {Default: "Created On From"} }}
                </mat-label>
                <input matInput [matDatepicker]="createdOnFromPicker" [(ngModel)]="filterCreatedOnFrom" (dateChange)="changeCreatedOnFrom($event)">
                <span fxLayout="row" matSuffix>
                    <mat-datepicker-toggle [for]="createdOnFromPicker"></mat-datepicker-toggle>
                </span>
                <mat-datepicker #createdOnFromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>
                    {{ 'CreatedOnTo' | translate: {Default: "Created On To"} }}
                </mat-label>
                <input matInput [matDatepicker]="createdOnToPicker" [(ngModel)]="filterCreatedOnTo" (dateChange)="changeCreatedOnTo($event)">
                <span fxLayout="row" matSuffix>
                    <mat-datepicker-toggle [for]="createdOnToPicker"></mat-datepicker-toggle>
                </span>
                <mat-datepicker #createdOnToPicker></mat-datepicker>
            </mat-form-field>

            <button appLocalizationPopupDirective localizationCode="ClearFilters" mat-stroked-button class="clear-filters-button" appPreventDoubleClick (throttledClick)="clearFilters()">
                <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">clear</mat-icon>
                {{ 'ClearFilters' | translate: {Default: "Clear Filters"} }}
            </button>
        </ng-template>


        <kendo-grid-column
            *ngFor="let col of columns"
            [field]="col.field"
            [title]="col.title"
            [width]="300"
        ></kendo-grid-column>

        <kendo-grid-excel
            fileName="AbsenceReport.xlsx"
            [fetchData]="allData"
        ></kendo-grid-excel>
    </kendo-grid>
</mat-card>

